var _excluded = ["radios", "onChange", "onClick", "value", "name", "containerProps", "variant", "children"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import { Div } from '@kizi/core-components';
import React, { useMemo } from 'react';
import { Radio } from '../components/Radio';
var defaultContainerProps = {
  display: 'flex',
  alignItems: 'center'
};
export var RadioGroup = function RadioGroup(_ref) {
  var radios = _ref.radios,
      _onChange = _ref.onChange,
      _onClick = _ref.onClick,
      value = _ref.value,
      name = _ref.name,
      containerProps = _ref.containerProps,
      variant = _ref.variant,
      children = _ref.children,
      divProps = _objectWithoutProperties(_ref, _excluded);

  var _radios = useMemo(function () {
    return (radios !== null && radios !== void 0 ? radios : []).map(function (radioProps, i) {
      var _radioProps$value, _radioProps$value2, _radioProps$pl;

      var isSelected = value === ((_radioProps$value = radioProps.value) === null || _radioProps$value === void 0 ? void 0 : _radioProps$value.toString()) && !radioProps.disabled;
      var conditionalVariant = variant ? {
        variant: variant
      } : {};
      return /*#__PURE__*/React.createElement(Div, {
        key: 'radio-' + name + '-' + i
      }, /*#__PURE__*/React.createElement(Radio, _extends({
        containerProps: _objectSpread(_objectSpread(_objectSpread({}, defaultContainerProps), containerProps), radioProps.containerProps)
      }, radioProps, conditionalVariant, {
        name: name,
        checked: value === ((_radioProps$value2 = radioProps.value) === null || _radioProps$value2 === void 0 ? void 0 : _radioProps$value2.toString()) && !radioProps.disabled,
        onChange: function onChange(e) {
          if (_onChange) _onChange(e);
        },
        onClick: function onClick(e) {
          if (_onClick) _onClick(e);
        }
      })), radioProps.hasChildren && isSelected && /*#__PURE__*/React.createElement(Div, {
        my: 3,
        pl: (_radioProps$pl = radioProps.pl) !== null && _radioProps$pl !== void 0 ? _radioProps$pl : 6
      }, children));
    });
  }, [radios, value, name, containerProps]);

  return /*#__PURE__*/React.createElement(Div, divProps, _radios);
};